<template>
  <el-dialog
    class="dialog-container"
    :title="title"
    :visible.sync="dialogVisible"
    :width="['zh', 'fa'].includes($i18n.locale) ? '900px' : '1100px'"
    append-to-body
    destroy-on-close
  >
    <div slot="title" class="header-title">
      <img src="@/assets/image/newIssue.png" alt="" />
      <span>{{ title }}</span>
    </div>
    <el-form
      ref="form"
      :model="form"
      :rules="formRules"
      :label-width="labelWidth"
    >
      <!-- 第一部分：基本信息 -->
      <div class="form-basic">
        <div class="titleTips">
          <img src="@/assets/image/basicIcon.png" alt="" />
          <span>{{ $t("zlfk.jbxx") }}</span>
        </div>
        <!-- 销售订单号 -->
        <el-form-item :label="$t('zlfk.xsddh') + ':'" prop="orderNum">
          <el-input
            v-model="form.orderNum"
            :placeholder="$t('placeholder.enter')"
          />
        </el-form-item>
        <!-- 车型 -->
        <el-form-item :label="$t('home.carType') + ':'" prop="carModel">
          <el-input
            v-model="form.carModel"
            :placeholder="$t('placeholder.enter')"
          />
        </el-form-item>
        <!-- 订单车辆数量 -->
        <el-form-item :label="$t('zlfk.ddclsl') + ':'" prop="carTotal">
          <el-input-number
            class="number-input"
            :controls="false"
            :precision="0"
            :min="0"
            v-model="form.carTotal"
            :placeholder="$t('placeholder.enter')"
          >
          </el-input-number>
          <div class="number-input-append">{{ $t("zlfk.tai") }}</div>
        </el-form-item>
        <!-- 故障发生日期 -->
        <el-form-item :label="$t('zlfk.gzfsrq') + ':'" prop="happenDate">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            v-model="form.happenDate"
            :placeholder="$t('placeholder.select')"
          ></el-date-picker>
        </el-form-item>
        <!-- 严重程度 -->
        <el-form-item
          :label="$t('restock.issueSeverity') + ':'"
          prop="issueSeverity"
        >
          <el-select v-model="form.issueSeverity" filterable clearable>
            <el-option
              v-for="(item, index) in severityDataKD"
              :key="index"
              :label="item.label"
              :value="item.code"
            >
              <el-tooltip placement="right" effect="light">
                <div
                  slot="content"
                  class="severityTips"
                  v-html="item['desc' + $i18n.locale]"
                ></div>
                <span>{{ item.label }}</span>
              </el-tooltip>
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 反馈单目的 -->
        <el-form-item
          :label="$t('restock.feedbackPurpose') + ':'"
          prop="feedbackPurpose"
        >
          <el-select v-model="form.feedbackPurpose" filterable multiple>
            <el-option
              :label="$t('restock.qualityImprove')"
              value="1"
            ></el-option>
            <el-option
              :label="$t('restock.claimRecord')"
              value="2"
            ></el-option>
            <el-option :label="$t('restock.urgentPart')" value="3"></el-option>
            <el-option :label="$t('restock.techAssist')" value="4"></el-option>
          </el-select>
        </el-form-item>
        <!-- 补件方式 -->
        <el-form-item v-if="form.feedbackPurpose && form.feedbackPurpose.includes('3')" :label="$t('restock.patchMode') + ':'" prop="patchMode">
          <el-select v-model="form.patchMode" filterable clearable>
            <el-option :label="$t('restock.patchModeAir')" :value="1"></el-option>
            <el-option :label="$t('restock.patchModeKD')" :value="2"></el-option>
            <el-option :label="$t('restock.patchModeParts')" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <!-- 故障配件数量 -->
        <el-form-item :label="$t('zlfk.gzpjsl') + ':'" prop="faultTotal">
          <el-input-number
            disabled
            :controls="false"
            :precision="0"
            v-model="form.faultTotal"
          >
          </el-input-number>
        </el-form-item>
        <!-- 是否重点问题 -->
        <el-form-item :label="$t('zlfk.sfzdwt') + ':'" prop="importantType">
          <el-radio-group v-model="form.importantType">
            <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 重点问题描述 -->
        <el-form-item
          v-if="form.importantType === 1"
          :label="$t('zlfk.zdwtms') + ':'"
          prop="importantDescribe"
        >
          <el-input
            v-model="form.importantDescribe"
            :placeholder="$t('placeholder.enter')"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <!-- 是否有维修措施 -->
        <el-form-item :label="$t('zlfk.sfywxcs') + ':'" prop="serviceMeasure">
          <el-radio-group v-model="form.serviceMeasure">
            <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 客户海外KD工厂处置方案 -->
        <el-form-item
          :label="$t('restockInfo.kdcswxcs') + ':'"
          prop="marketService"
          v-if="form.serviceMeasure == 1"
        >
          <el-input
            v-model="form.marketService"
            :placeholder="$t('placeholder.enter')"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <!-- 零部件类别 -->
        <el-form-item
          :label="$t('restock.componentType') + ':'"
          prop="componentType"
        >
          <el-select
            v-model="form.componentType"
            filterable
            clearable
            @change="$refs.tableRef.doLayout()"
          >
            <el-option
              v-for="(item, index) in componentCategoryList"
              :key="index"
              :label="item[componentCategoryName.get($i18n.locale)]"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 故障配件编码 -->
        <div>
          <el-form-item
            :label="$t('restock.gzpjbm') + ':'"
            prop="vinCheckRespList"
          >
            <!-- 表格内容 -->
            <div class="table-container">
              <div class="table-btn">
                <!-- 添加 -->
                <el-button
                  class="primary-btn"
                  type="primary"
                  icon="el-icon-plus"
                  @click="handleAdd"
                  >{{ $t("zlfk.tj") }}</el-button
                >
                <!-- 批量导入 -->
                <el-button
                  class="primary-btn"
                  icon="el-icon-upload2"
                  plain
                  @click="handleImport"
                  >{{ $t("zlfk.pldr") }}</el-button
                >
              </div>
              <el-table
                ref="tableRef"
                stripe
                border
                highlight-current-row
                :data="form.vinCheckRespList"
              >
                <!-- 外包装箱号 -->
                <el-table-column
                  property="outBoxNo"
                  min-width="180px"
                  align="center"
                >
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>{{ $t("restock.wbzxh") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'vinCheckRespList.' + scope.$index + '.outBoxNo'"
                      :rules="{ required: true, message: ' ' }"
                    >
                      <el-input
                        v-model="scope.row.outBoxNo"
                        :placeholder="$t('placeholder.enter')"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 纸箱号 -->
                <el-table-column
                  property="paperNo"
                  min-width="180px"
                  align="center"
                >
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>{{ $t("restock.zxh") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'vinCheckRespList.' + scope.$index + '.paperNo'"
                      :rules="{ required: true, message: ' ' }"
                    >
                      <el-input
                        v-model="scope.row.paperNo"
                        :placeholder="$t('placeholder.enter')"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 配件编码 -->
                <el-table-column
                  property="faultCode"
                  min-width="180px"
                  align="center"
                >
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>{{ $t("restock.pjbm") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'vinCheckRespList.' + scope.$index + '.faultCode'"
                      :rules="{ required: true, message: ' ' }"
                    >
                      <el-autocomplete
                        class="table-auto-input"
                        :ref="'autocomplete' + scope.$index"
                        v-model="scope.row.faultCode"
                        :placeholder="$t('placeholder.enter')"
                        :fetch-suggestions="getFaultList"
                        @select="handleSelect($event, scope.$index)"
                        @keyup.enter.native="
                          handleInput('autocomplete' + scope.$index)
                        "
                        @blur="onBlurFault(scope.$index)"
                      ></el-autocomplete>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 配件名称 -->
                <el-table-column
                  property="faultName"
                  :label="$t('restock.pjmc')"
                  min-width="180px"
                  :render-header="$globalRenderHeader"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-form-item>
                      <el-input
                        v-model="scope.row.faultName"
                        :placeholder="$t('placeholder.enter')"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 故障配件数量 -->
                <el-table-column
                  property="faultNumber"
                  min-width="180px"
                  align="center"
                >
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>{{ $t("zlfk.gzpjsl") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <div class="table-number-input">
                      <el-form-item
                        :prop="
                          'vinCheckRespList.' + scope.$index + '.faultNumber'
                        "
                        :rules="{ required: true, message: ' ' }"
                      >
                        <el-input-number
                          :controls="false"
                          :precision="0"
                          v-model="scope.row.faultNumber"
                          :placeholder="$t('placeholder.enter')"
                        >
                        </el-input-number>
                      </el-form-item>
                    </div>
                  </template>
                </el-table-column>
                <!-- 发动机型号 -->
                <el-table-column
                  v-if="form.componentType == 1"
                  key="engineType"
                  property="engineType"
                  min-width="180px"
                  align="center"
                >
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>{{ $t("restock.engineType") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'vinCheckRespList.' + scope.$index + '.engineType'"
                      :rules="{
                        required: form.componentType == 1,
                        message: ' ',
                      }"
                    >
                      <el-input
                        v-model="scope.row.engineType"
                        :placeholder="$t('placeholder.enter')"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 发动机号 -->
                <el-table-column
                  v-if="form.componentType == 1"
                  key="engineNo"
                  property="engineNo"
                  min-width="180px"
                  align="center"
                >
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>{{ $t("restock.engineNo") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'vinCheckRespList.' + scope.$index + '.engineNo'"
                      :rules="{
                        required: form.componentType == 1,
                        message: ' ',
                      }"
                    >
                      <el-input
                        v-model="scope.row.engineNo"
                        :placeholder="$t('placeholder.enter')"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 订单批次号 -->
                <el-table-column
                  property="orderBatch"
                  min-width="180px"
                  align="center"
                >
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>{{ $t("zlfk.ddpch") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'vinCheckRespList.' + scope.$index + '.orderBatch'"
                      :rules="{ required: true, message: ' ' }"
                    >
                      <el-input
                        v-model="scope.row.orderBatch"
                        :placeholder="$t('placeholder.enter')"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 零部件批次号 -->
                <el-table-column
                  property="partBatchNo"
                  min-width="180px"
                  align="center"
                >
                  <template #header>
                    <span>{{ $t("restock.partBatchNo") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="
                        'vinCheckRespList.' + scope.$index + '.partBatchNo'
                      "
                    >
                      <el-input
                        v-model="scope.row.partBatchNo"
                        :placeholder="$t('placeholder.enter')"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 供应商代码 -->
                <el-table-column
                  property="supplierCode"
                  min-width="180px"
                  align="center"
                >
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>{{ $t("restock.supplierCode") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="
                        'vinCheckRespList.' + scope.$index + '.supplierCode'
                      "
                      :rules="{ required: true, message: ' ' }"
                    >
                      <el-input
                        v-model="scope.row.supplierCode"
                        :placeholder="$t('placeholder.enter')"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 故障类别 -->
                <el-table-column
                  property="faultType"
                  min-width="180px"
                  align="center"
                >
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>{{ $t("zlfk.gzlb") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'vinCheckRespList.' + scope.$index + '.faultType'"
                      :rules="{ required: true, message: ' ' }"
                    >
                      <el-select
                        filterable
                        clearable
                        v-model="scope.row.faultType"
                        :placeholder="$t('placeholder.select')"
                      >
                        <el-option
                          v-for="(item, index) in kdFaultTypeList.filter(
                            (item) => item.codeText === $i18n.locale
                          )"
                          :key="index"
                          :label="item.value"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 维修方案 -->
                <el-table-column
                  property="repairPlan"
                  min-width="180px"
                  align="center"
                >
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>{{ $t("zlfk.wxfa") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'vinCheckRespList.' + scope.$index + '.repairPlan'"
                      :rules="{ required: true, message: ' ' }"
                    >
                      <el-select
                        filterable
                        clearable
                        v-model="scope.row.repairPlan"
                        :placeholder="$t('placeholder.select')"
                      >
                        <el-option
                          v-for="(item, index) in kdRepairPlanList.filter(
                            (item) => item.codeText === $i18n.locale
                          )"
                          :key="index"
                          :label="item.value"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 单车用量 -->
                <el-table-column
                  property="singleDosage"
                  :label="$t('zlfk.dcyl')"
                  min-width="180px"
                  :render-header="$globalRenderHeader"
                  align="center"
                >
                  <template slot-scope="scope">
                    <div class="table-number-input">
                      <el-form-item>
                        <el-input-number
                          class="number-input"
                          :controls="false"
                          :precision="0"
                          v-model="scope.row.singleDosage"
                          :placeholder="$t('placeholder.enter')"
                        >
                        </el-input-number>
                      </el-form-item>
                    </div>
                  </template>
                </el-table-column>
                <!-- 到港时间 -->
                <el-table-column
                  property="arrivalTime"
                  min-width="180px"
                  align="center"
                >
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>{{ $t("restock.arrivalTime") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="
                        'vinCheckRespList.' + scope.$index + '.arrivalTime'
                      "
                      :rules="{ required: true, message: ' ' }"
                    >
                      <el-date-picker
                        v-model="scope.row.arrivalTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        :placeholder="$t('placeholder.select')"
                      ></el-date-picker>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 开箱时间 -->
                <el-table-column
                  property="unboxingTime"
                  min-width="180px"
                  align="center"
                >
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>{{ $t("restock.unboxingTime") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="
                        'vinCheckRespList.' + scope.$index + '.unboxingTime'
                      "
                      :rules="{ required: true, message: ' ' }"
                    >
                      <el-date-picker
                        v-model="scope.row.unboxingTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        :placeholder="$t('placeholder.select')"
                      ></el-date-picker>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 上线时间 -->
                <el-table-column
                  property="onlineTime"
                  min-width="180px"
                  align="center"
                >
                  <template #header>
                    <span class="symbolColor">*</span>
                    <span>{{ $t("restock.onlineTime") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'vinCheckRespList.' + scope.$index + '.onlineTime'"
                      :rules="{ required: true, message: ' ' }"
                    >
                      <el-date-picker
                        v-model="scope.row.onlineTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        :placeholder="$t('placeholder.select')"
                      ></el-date-picker>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 操作 -->
                <el-table-column
                  :label="$t('cart.operate')"
                  align="center"
                  width="90px"
                  :render-header="$globalRenderHeader"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->
                    <el-button
                      type="text"
                      @click="handleDelete(scope.row, scope.$index)"
                      >{{ $t("cart.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </div>
        <!-- 问题描述 -->
        <div class="form-basic">
          <div class="titleTips">
            <img src="@/assets/image/wtmsIcon.png" alt="" />
            {{ $t("zlfk.wtms") }}
          </div>
          <!-- 故障现象描述 -->
          <el-form-item
            :label="$t('restock.faultDescription') + ':'"
            prop="questionContent"
          >
            <el-input
              v-model="form.questionContent"
              :placeholder="$t('placeholder.enter')"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            />
          </el-form-item>
          <!-- 附件 -->
          <!-- <el-form-item :label="$t('zlfk.fj')+':'">
            <drag-upload :accessory-list.sync="form.questionDescriptionAndFiles.faultDescriptionList" :limit="10" :httpRequest="action" uploadType="paste"></drag-upload>
          </el-form-item> -->
        </div>
        <!-- 图片和视频 -->
        <div class="form-basic">
          <div class="titleTips">
            <img src="@/assets/image/ImgIcon.png" alt="" />
            {{ $t("restock.pictureAndVideo") }}
          </div>
          <fileUploadTips></fileUploadTips>
          <!-- 包装箱拆箱前整体图片/视频 -->
          <div class="radio-upload-group">
            <el-form-item
              :label="$t('restock.isUnboxOverall') + ':'"
              prop="questionDescriptionAndFiles.isUnboxOverall"
            >
              <el-radio-group
                v-model="form.questionDescriptionAndFiles.isUnboxOverall"
              >
                <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
                <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="form.questionDescriptionAndFiles.isUnboxOverall === 1"
              :label="$t('zlfk.fj') + ':'"
              prop="questionDescriptionAndFiles.unboxOverallList"
            >
              <drag-upload
                :accessory-list.sync="
                  form.questionDescriptionAndFiles.unboxOverallList
                "
                :httpRequest="action"
                uploadType="paste"
                :tipStatus="false"
              ></drag-upload>
            </el-form-item>
          </div>

          <!-- 包装箱粘贴标签图片 -->
          <div class="radio-upload-group">
            <el-form-item
              :label="$t('restock.isBoxLabel') + ':'"
              prop="questionDescriptionAndFiles.isBoxLabel"
            >
              <el-radio-group
                v-model="form.questionDescriptionAndFiles.isBoxLabel"
              >
                <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
                <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="form.questionDescriptionAndFiles.isBoxLabel === 1"
              :label="$t('zlfk.fj') + ':'"
              prop="questionDescriptionAndFiles.boxLabelList"
            >
              <drag-upload
                :accessory-list.sync="
                  form.questionDescriptionAndFiles.boxLabelList
                "
                :httpRequest="action"
                uploadType="paste"
                :tipStatus="false"
              ></drag-upload>
            </el-form-item>
          </div>

          <!-- 包装箱损坏局部图片/视频 -->
          <div class="radio-upload-group">
            <el-form-item
              :label="$t('restock.isBoxDamage') + ':'"
              prop="questionDescriptionAndFiles.isBoxDamage"
            >
              <el-radio-group
                v-model="form.questionDescriptionAndFiles.isBoxDamage"
              >
                <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
                <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="form.questionDescriptionAndFiles.isBoxDamage === 1"
              :label="$t('zlfk.fj') + ':'"
              prop="questionDescriptionAndFiles.boxDamageList"
            >
              <drag-upload
                :accessory-list.sync="
                  form.questionDescriptionAndFiles.boxDamageList
                "
                :httpRequest="action"
                uploadType="paste"
                :tipStatus="false"
              ></drag-upload>
            </el-form-item>
          </div>

          <!-- 零部件整体图片 -->
          <div class="radio-upload-group">
            <el-form-item
              :label="$t('restock.isPartOverall') + ':'"
              prop="questionDescriptionAndFiles.isPartOverall"
            >
              <el-radio-group
                v-model="form.questionDescriptionAndFiles.isPartOverall"
              >
                <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
                <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="form.questionDescriptionAndFiles.isPartOverall === 1"
              :label="$t('zlfk.fj') + ':'"
              prop="questionDescriptionAndFiles.partOverallList"
            >
              <drag-upload
                :accessory-list.sync="
                  form.questionDescriptionAndFiles.partOverallList
                "
                :httpRequest="action"
                uploadType="paste"
                :tipStatus="false"
              ></drag-upload>
            </el-form-item>
          </div>

          <!-- 零部件局部图片/视频 -->
          <div class="radio-upload-group">
            <el-form-item
              :label="$t('restock.isPartDetail') + ':'"
              prop="questionDescriptionAndFiles.isPartDetail"
            >
              <el-radio-group
                v-model="form.questionDescriptionAndFiles.isPartDetail"
              >
                <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
                <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="form.questionDescriptionAndFiles.isPartDetail === 1"
              :label="$t('zlfk.fj') + ':'"
              prop="questionDescriptionAndFiles.partDetailList"
            >
              <drag-upload
                :accessory-list.sync="
                  form.questionDescriptionAndFiles.partDetailList
                "
                :httpRequest="action"
                uploadType="paste"
                :tipStatus="false"
              ></drag-upload>
            </el-form-item>
          </div>

          <!-- 零部件对比图片(错/漏发/状态不对) -->
          <div class="radio-upload-group">
            <el-form-item
              :label="$t('restock.isPartComparison') + ':'"
              prop="questionDescriptionAndFiles.isPartComparison"
            >
              <el-radio-group
                v-model="form.questionDescriptionAndFiles.isPartComparison"
              >
                <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
                <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="form.questionDescriptionAndFiles.isPartComparison === 1"
              :label="$t('zlfk.fj') + ':'"
              prop="questionDescriptionAndFiles.partComparisonList"
            >
              <drag-upload
                :accessory-list.sync="
                  form.questionDescriptionAndFiles.partComparisonList
                "
                :httpRequest="action"
                uploadType="paste"
                :tipStatus="false"
              ></drag-upload>
            </el-form-item>
          </div>

          <!-- 供应商信息图片 -->
          <div class="radio-upload-group">
            <el-form-item
              :label="$t('restock.isSupplierInfo') + ':'"
              prop="questionDescriptionAndFiles.isSupplierInfo"
            >
              <el-radio-group
                v-model="form.questionDescriptionAndFiles.isSupplierInfo"
              >
                <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
                <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="form.questionDescriptionAndFiles.isSupplierInfo === 1"
              :label="$t('zlfk.fj') + ':'"
              prop="questionDescriptionAndFiles.supplierInfoList"
            >
              <drag-upload
                :accessory-list.sync="
                  form.questionDescriptionAndFiles.supplierInfoList
                "
                :httpRequest="action"
                uploadType="paste"
                :tipStatus="false"
              ></drag-upload>
            </el-form-item>
          </div>

          <!-- 其他辅助证据/视频资料 -->
          <div class="radio-upload-group">
            <el-form-item
              :label="$t('restock.isOtherEvidence') + ':'"
              prop="questionDescriptionAndFiles.isOtherEvidence"
            >
              <el-radio-group
                v-model="form.questionDescriptionAndFiles.isOtherEvidence"
              >
                <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
                <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <template
              v-if="form.questionDescriptionAndFiles.isOtherEvidence === 1"
            >
              <el-form-item
                :label="$t('cart.remark') + ':'"
                prop="questionDescriptionAndFiles.remark"
              >
                <el-input
                  type="textarea"
                  v-model="form.questionDescriptionAndFiles.remark"
                  :placeholder="$t('placeholder.enter')"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  maxlength="500"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('zlfk.fj') + ':'"
                prop="questionDescriptionAndFiles.otherEvidenceList"
              >
                <drag-upload
                  :accessory-list.sync="
                    form.questionDescriptionAndFiles.otherEvidenceList
                  "
                  :httpRequest="action"
                  uploadType="paste"
                  :tipStatus="false"
                ></drag-upload>
              </el-form-item>
            </template>
          </div>
        </div>
      </div>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button
        class="primary-btn lang-but"
        type="primary"
        @click="handleSave"
      >
        {{ $t("seek.submit") }}
        <!-- {{ form.submit ? $t("seek.submit") : $t("home.confirm") }} -->
      </el-button>
      <el-button
        class="primary-btn lang-but"
        plain
        @click="dialogVisible = false"
        >{{ $t("seek.cancel") }}</el-button
      >
    </div>
    <import-model-dialog
      ref="importModelDialog"
      :uploadUrl="uploadUrl"
      :templateUrl="templateUrl[$i18n.locale]"
      @success="getList"
    />
  </el-dialog>
</template>

<script>
import { problemAddApi, problemEditApi } from "@/api/qualityKD";
import { getECPData } from "@/api/seek";
import ImportModelDialog from "@/components/importModelDialog.vue";
import { uploadUrl } from "@/util/url";
import { getDictItem } from "@/util/dict";
import CryptoJS from "crypto-js";
import { getSession } from "@/util/localStor";
import faultData from "@/mixins/faultData";
import fileUploadTips from "@/components/fileUpload/fileUploadTips";
export default {
  components: { ImportModelDialog, fileUploadTips },
  mixins: [faultData],
  props: {},
  data() {
    return {
      kdFaultTypeList: [], // 故障类型列表
      kdRepairPlanList: [], // 维修方案列表
      faultList: [], // 配件编码列表
      title: "", // 弹窗标题
      dialogVisible: false, // 弹窗显示
      form: this.getForm(), // 表单数据
      action: "/customer/quality/upload", // 附件上传地址
      uploadUrl: uploadUrl + "/customer/kd/feedback/importFault", // 导入地址
      templateUrl: {
        zh: "https://bucket-shineray-dev-oversea.xinan1.zos.ctyun.cn/dev/excel/excelPath/2026/01/11/ed806c591e64464e834a3544fb06e5fe.xlsx",
        en: "https://shineray-dev-oversea.oss-cn-chengdu.aliyuncs.com/importTemplate/kdQuesionFault/Template for importing faulty accessories.xlsx",
        ru: "https://shineray-dev-oversea.oss-cn-chengdu.aliyuncs.com/importTemplate/kdQuesionFault/Шаблон импорта неисправных аксессуаров.xlsx",
        fa: "https://shineray-dev-oversea.oss-cn-chengdu.aliyuncs.com/importTemplate/kdQuesionFault/نمونه برای وارد دسترسی اشتباهی.xlsx",
      },
    };
  },
  created() {
    this.getkdFaultTypeList();
    this.getkdRepairPlanList();
    this.getTypeList();
  },
  computed: {
    labelWidth() {
      const widthMap = {
        zh: "245px",
        ru: "340px",
        en: "260px",
        vi: "240px",
        es: "305px",
        fa: "215px",
      };
      return widthMap[this.$i18n.locale] || "200px";
    },
    // 表单验证
    formRules() {
      // 公共规则配置
      const commonRule = {
        required: true,
        trigger: ["change", "blur"],
        message: this.$t("restockInfo.nullTip"),
      };
      return {
        ...Object.fromEntries(
          [
            "orderNum",
            "carModel",
            "carTotal",
            "happenDate",
            "issueSeverity",
            "feedbackPurpose",
            "importantType",
            "importantDescribe",
            "serviceMeasure",
            "marketService",
            "componentType",
            "vinCheckRespList",
            "questionContent",
            "questionDescriptionAndFiles.isUnboxOverall",
            "questionDescriptionAndFiles.unboxOverallList",
            "questionDescriptionAndFiles.isBoxLabel",
            "questionDescriptionAndFiles.boxLabelList",
            "questionDescriptionAndFiles.isBoxDamage",
            "questionDescriptionAndFiles.isBoxDamage",
            "questionDescriptionAndFiles.boxDamageList",
            "questionDescriptionAndFiles.isPartOverall",
            "questionDescriptionAndFiles.partOverallList",
            "questionDescriptionAndFiles.isPartDetail",
            "questionDescriptionAndFiles.partDetailList",
            "questionDescriptionAndFiles.isPartComparison",
            "questionDescriptionAndFiles.partComparisonList",
            "questionDescriptionAndFiles.isSupplierInfo",
            "questionDescriptionAndFiles.supplierInfoList",
            "questionDescriptionAndFiles.isOtherEvidence",
            "questionDescriptionAndFiles.remark",
            "questionDescriptionAndFiles.otherEvidenceList",
          ].map((field) => [field, commonRule])
        ),
        // patchMode: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (Array.isArray(this.form.feedbackPurpose) && this.form.feedbackPurpose.includes('3') && !value) {
        //         callback(new Error(this.$t("restockInfo.nullTip")));
        //       } else {
        //         callback();
        //       }
        //     },
        //     required: true,
        //     trigger: "change",
        //   },
        // ],
      };
    },
  },
  watch: {
    "form.vinCheckRespList": {
      deep: true,
      handler(val) {
        this.form.faultTotal = 0;
        val.map((item, index) => {
          this.form.faultTotal += item.faultNumber || 0;
        });
      },
    },
  },
  methods: {
    // 获取车型列表
    async getkdFaultTypeList() {
      const res = await getDictItem("kdFaultType");
      this.kdFaultTypeList = res || [];
    },
    // 获取维修方案
    async getkdRepairPlanList() {
      const res = await getDictItem("kdRepairPlan");
      this.kdRepairPlanList = res || [];
    },
    // 初始化
    async init(title, data = {}) {
      this.title = title;
      this.dialogVisible = true;
      this.form = this.getForm(data);
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
        this.detectLabelOverflow();
      });
    },
    // 获取表单对象
    getForm(data = {}) {
      let qdf = {};
      try {
        if (
          data.questionDescriptionAndFiles &&
          typeof data.questionDescriptionAndFiles === "string"
        ) {
          qdf = JSON.parse(data.questionDescriptionAndFiles);
        } else if (
          data.questionDescriptionAndFiles &&
          typeof data.questionDescriptionAndFiles === "object"
        ) {
          qdf = data.questionDescriptionAndFiles;
        }
      } catch (e) {
        console.error("Failed to parse questionDescriptionAndFiles", e);
      }
      return {
        feedbackFormId: data.feedbackFormId || "",
        questionId: data.questionId || "",
        orderNum: data.orderNum || "",
        carModel: data.carModel || "",
        carTotal: data.carTotal || undefined,
        happenDate: data.happenDate || "",
        issueSeverity: data.issueSeverity || "",
        feedbackPurpose: data.feedbackPurpose ? String(data.feedbackPurpose).split(",") : undefined,
        patchMode: data.patchMode || undefined,
        componentType: data.componentType ?? undefined,
        faultTotal: data.faultTotal || undefined,
        questionContent: data.questionContent || "",
        serviceMeasure: data.serviceMeasure ?? 1,
        marketService: data.marketService || "",
        nowTaskId: data.nowTaskId || "",
        importantType: data.importantType ?? 1,
        importantDescribe: data.importantDescribe || "",
        questionDescriptionAndFiles: {
          faultDescription: qdf.faultDescription || data.faultDescription || "",
          faultDescriptionList:
            qdf.faultDescriptionList || data.faultDescriptionList || [],
          isUnboxOverall: qdf.isUnboxOverall ?? data.isUnboxOverall ?? 1,
          unboxOverallList: qdf.unboxOverallList || data.unboxOverallList || [],
          isBoxLabel: qdf.isBoxLabel ?? data.isBoxLabel ?? 1,
          boxLabelList: qdf.boxLabelList || data.boxLabelList || [],
          isBoxDamage: qdf.isBoxDamage ?? data.isBoxDamage ?? 1,
          boxDamageList: qdf.boxDamageList || data.boxDamageList || [],
          isPartOverall: qdf.isPartOverall ?? data.isPartOverall ?? 1,
          partOverallList: qdf.partOverallList || data.partOverallList || [],
          isPartDetail: qdf.isPartDetail ?? data.isPartDetail ?? 1,
          partDetailList: qdf.partDetailList || data.partDetailList || [],
          isPartComparison: qdf.isPartComparison ?? data.isPartComparison ?? 1,
          partComparisonList:
            qdf.partComparisonList || data.partComparisonList || [],
          isSupplierInfo: qdf.isSupplierInfo ?? data.isSupplierInfo ?? 1,
          supplierInfoList: qdf.supplierInfoList || data.supplierInfoList || [],
          isOtherEvidence: qdf.isOtherEvidence ?? data.isOtherEvidence ?? 1,
          otherEvidenceList:
            qdf.otherEvidenceList || data.otherEvidenceList || [],
          remark: qdf.remark || data.remark || "",
        },
        vinCheckRespList: data.vinCheckRespList
          ? JSON.parse(JSON.stringify(data.vinCheckRespList))
          : [],
        delList: [], // 删除故障配件列表记录
        submit: data.status === 3 ? true : false,
        status: data.status || 0,
      };
    },
    // 获取ECP接口参数
    getECPParams() {
      const appId = "586738eb-49ed-4289-b951-193bfee3452b";
      const authToken = "298714f9-b43c-4772-b259-e6e2728cbd91";
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");
      const timestamp =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      // 拼接appId、authToken和timestamp三个参数后，进行MD5摘要得到16进制摘要字符串，然后转大写得到签名
      const concat = appId + authToken + timestamp;
      const sign = CryptoJS.MD5(concat).toString().toUpperCase();
      return { appId, timestamp, sign };
    },
    // 根据故障件件号（配件编码），EPC系统获取故障件（配件）
    async getFault(queryString) {
      const { appId, timestamp, sign } = this.getECPParams();
      const params = {
        appId,
        timestamp,
        sign,
        codeList: [queryString],
        account: getSession("person").customerAccountNum,
      };
      const res = await getECPData(params);
      const faultList = res.data;
      return faultList;
    },
    // 获取故障件列表
    async getFaultList(queryString, cb) {
      if (queryString && queryString.length >= 7) {
        const faultList = await this.getFault(queryString);
        this.faultList = [];
        faultList?.map((item) => {
          this.faultList.push({ ...item, zh: item.name, value: item.code });
        });
      } else {
        this.faultList = [];
      }
      cb(this.faultList);
    },
    // 输入故障件
    handleInput(ref) {
      this.$refs[ref].$refs.input.blur(); // 取消焦点
      this.$refs[ref].activated = false; // 关闭下拉框
    },
    // 表格输入故障件获取数据
    async onBlurFault(index) {
      if (
        this.faultList.length === 0 &&
        this.form.vinCheckRespList[index].faultCode.length >= 7
      ) {
        const faultList = await this.getFault(
          this.form.vinCheckRespList[index].faultCode
        );
        this.faultList = [];
        faultList?.map((item) => {
          this.faultList.push({ ...item, zh: item.name, value: item.code });
        });
      }
      const faultIndex = this.faultList.findIndex((item) => {
        return item.code === this.form.vinCheckRespList[index].faultCode;
      });
      if (faultIndex !== -1) {
        this.form.vinCheckRespList[index].faultName =
          this.faultList[faultIndex][this.$i18n.locale] ||
          this.faultList[faultIndex].en ||
          this.faultList[faultIndex].zh;
      }
    },
    // 选择故障件
    handleSelect(item, index) {
      this.form.vinCheckRespList[index].faultName =
        item[this.$i18n.locale] || item.en || item.zh;
    },
    // 添加故障件
    handleAdd() {
      this.form.vinCheckRespList.unshift({
        outBoxNo: "",
        paperNo: "",
        faultCode: "",
        faultName: "",
        orderBatch: "",
        faultNumber: undefined,
        faultType: "",
        repairPlan: "",
        singleDosage: undefined,
      });
    },
    // 删除故障件
    handleDelete({ id }, index) {
      id && this.form.delList.push({ id: id });
      this.form.vinCheckRespList.splice(index, 1);
    },
    // 批量导入故障件
    handleImport() {
      this.$refs.importModelDialog.init(this.$t("zlfk.pldr"));
    },
    // 导入成功列表
    getList(data) {
      this.form.vinCheckRespList = [...this.form.vinCheckRespList, ...data];
    },
    // 表单校验
    getRequiredTips(object) {
      const propLabelMap = {
        orderNum: "zlfk.xsddh",
        carModel: "home.carType",
        carTotal: "zlfk.ddclsl",
        happenDate: "zlfk.gzfsrq",
        issueSeverity: "restock.issueSeverity",
        feedbackPurpose: "restock.feedbackPurpose",
        importantType: "zlfk.sfzdwt",
        importantDescribe: "zlfk.zdwtms",
        serviceMeasure: "zlfk.sfywxcs",
        marketService: "restockInfo.kdcswxcs",
        componentType: "restock.componentType",
        patchMode: "restock.patchMode",
        vinCheckRespList: "restock.gzpjbm",
        questionContent: "restock.faultDescription",
      };

      const tablePropLabelMap = {
        outBoxNo: "restock.wbzxh",
        paperNo: "restock.zxh",
        faultCode: "restock.pjbm",
        faultNumber: "zlfk.gzpjsl",
        engineType: "restock.engineType",
        engineNo: "restock.engineNo",
        orderBatch: "zlfk.ddpch",
        supplierCode: "restock.supplierCode",
        faultType: "zlfk.gzlb",
        repairPlan: "zlfk.wxfa",
        arrivalTime: "restock.arrivalTime",
        unboxingTime: "restock.unboxingTime",
        onlineTime: "restock.onlineTime",
      };

      let errorMessages = [];
      if (object) {
        Object.keys(object).forEach((prop) => {
          let label = "";
          if (propLabelMap[prop]) {
            label = this.$t(propLabelMap[prop]);
          } else if (prop.includes("vinCheckRespList")) {
            const parts = prop.split(".");
            const fieldName = parts[2];
            if (tablePropLabelMap[fieldName]) {
              label = this.$t(tablePropLabelMap[fieldName]);
            }
          } else if (prop.includes("questionDescriptionAndFiles")) {
            label = this.validateAttachments(prop);
          }
          if (label && !errorMessages.includes(label)) {
            errorMessages.push(label);
          }
        });
      }

      if (errorMessages.length > 0) {
        this.$DonMessage.warning(`${errorMessages.join(", ")}`);
      } else {
        this.$DonMessage.warning(this.$t("restockInfo.required"));
      }
    },
    // 图片和视频校验附件
    getCheckList() {
      const checkList = [
        {
          is: "isUnboxOverall",
          list: "unboxOverallList",
          label: "restock.isUnboxOverall",
        },
        {
          is: "isBoxLabel",
          list: "boxLabelList",
          label: "restock.isBoxLabel",
        },
        {
          is: "isBoxDamage",
          list: "boxDamageList",
          label: "restock.isBoxDamage",
        },
        {
          is: "isPartOverall",
          list: "partOverallList",
          label: "restock.isPartOverall",
        },
        {
          is: "isPartDetail",
          list: "partDetailList",
          label: "restock.isPartDetail",
        },
        {
          is: "isPartComparison",
          list: "partComparisonList",
          label: "restock.isPartComparison",
        },
        {
          is: "isSupplierInfo",
          list: "supplierInfoList",
          label: "restock.isSupplierInfo",
        },
        {
          is: "isOtherEvidence",
          list: "remark",
          label: "restock.isOtherEvidence",
        },
        {
          is: "isOtherEvidence",
          list: "otherEvidenceList",
          label: "restock.isOtherEvidence",
        },
      ];
      return checkList;
    },
    validateAttachments(prop) {
      //TODO 这段校验暂时去除掉
      // if (this.form.faultDescriptionList.length === 0) {
      //   this.$DonMessage.warning(
      //     this.$t("restock.faultDescription") +
      //       this.$t("seek.appendix") +
      //       this.$t("restock.fileNotNull")
      //   );
      //   return false;
      // }
      var checkList = this.getCheckList();
      let label = "";
      checkList.forEach((item) => {
        if (item.list == prop.split(".")[1]) {
          if (item.list == "remark") {
            label = `${this.$t(item.label)}-${this.$t("cart.remark")}`;
          } else {
            label = `${this.$t(item.label)}-${this.$t("zlfk.fj")}`;
          }
        }
      });
      return label;
    },
    // 保存
    handleSave() {
      // if (
      //   !this.form.vinCheckRespList ||
      //   this.form.vinCheckRespList.length === 0
      // ) {
      //   this.$DonMessage.warning(this.$t("zlfk.qtjgzpjbm"));
      //   return;
      // }
      // // 校验附件
      // if (!this.validateAttachments()) {
      //   return;
      // }
      if (!this.getFileUploadTip()) {
        return;
      }
      this.$refs.form.validate(async (valid, object) => {
        if (!valid) {
          this.getErrorLocation();
          this.getRequiredTips(object);
          return;
        }
        try {
          // this.form.questionContent = this.form.questionDescriptionAndFiles.faultDescription;
          const submitData = JSON.parse(JSON.stringify(this.form));
          Array.isArray(submitData.feedbackPurpose) && (submitData.feedbackPurpose = submitData.feedbackPurpose.join(","));
          submitData.importantType == 0 && (submitData.importantDescribe = "");
          submitData.serviceMeasure == 0 && (submitData.marketService = "");
          var checkList = this.getCheckList();
          checkList.forEach((item) => {
            if (submitData.questionDescriptionAndFiles[item.is] == 0) {
              if (item.list == "remark") {
                submitData.questionDescriptionAndFiles[item.list] = "";
              } else {
                submitData.questionDescriptionAndFiles[item.list] = [];
              }
            }
          });
          submitData.questionDescriptionAndFiles = JSON.stringify(
            submitData.questionDescriptionAndFiles
          );
          submitData["languageType"] = this.$i18n.locale;
          submitData.vinCheckRespList.map((item, index) => {
            // 获取故障类型中文字典项
            const zhFaultTypeDictItem = this.kdFaultTypeList.find((item2) => {
              return item.faultType === item2.value;
            });
            submitData.vinCheckRespList[index].faultTypeZh =
              zhFaultTypeDictItem.code.slice(0, -2);
            // 获取故障类型中文字典项
            const zhRepairPlanDictItem = this.kdRepairPlanList.find((item2) => {
              return item.repairPlan === item2.value;
            });
            submitData.vinCheckRespList[index].repairPlanZh =
              zhRepairPlanDictItem.code.slice(0, -2);
          });
          let res = {};
          if (submitData.questionId) {
            res = await problemEditApi({ data: submitData });
          } else {
            res = await problemAddApi({ data: submitData });
          }
          if (res.status == 0) {
            this.dialogVisible = false;
            this.$DonMessage.success(this.$t("message.czcg"));
            this.$emit("success", res.data);
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
      });
    },
  },
};
</script>
